export default __webpack_public_path__ + "static/media/IMG_5492.2d3cb529.jpg";